<establishment-main-categories
  [categories]="categories"
  (categorySelected)="onCategorySelected($event)"
  (subcategorySelected)="onSubcategorySelected($event)"
  (filterChanged)="onFilterChange($event.category, $event.subcategory)"
></establishment-main-categories>

